export default (productCode) => ({
  op: 'remove',
  path: `/flowConfig/${productCode}`,
});
